/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_CancelInputs */

const vi_order_action_cancel = /** @type {(inputs: Order_Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy đơn`)
};

/**

* @param {Order_Action_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_cancel = /** @type {((inputs?: Order_Action_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_cancel(inputs)
});